module.exports = __webpack_public_path__ + "static/media/canada.88c1148a.svg";